// module_configs/autos.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,
  faLayerGroup, faBoxes, faCog, faCar, faWrench, faOilCan, faToolbox, faHistory,
  faDroplet, faClock, faCarOn, faTachometerAlt, faUsersCog
} from '@fortawesome/free-solid-svg-icons';

// Import Autos components (assuming similar to mechanics)
import DashboardHome from '.././module_cosmetics/cosmetics_homedash';
import AddCustomer from '.././module_mechanics/mechanics_customer';
import CustomerList from '.././module_mechanics/mechanics_customer_list';
import AddSupplier from '.././module_mechanics/mechanics_Supplier';
import SupplierList from '.././module_mechanics/mechanics_SuppliersList';
import AddEmployee from '.././module_mechanics/mechanics_employees';
import MecEmployeeList from '.././module_mechanics/mechanic_employeelist';
import CarList from '.././module_mechanics/mechanics_carlist';
import ServiceNameList from '.././module_mechanics/mechanics_serviceslist';
import ServiceForm from '.././module_mechanics/mechanics_services';
import ServiceList from '.././module_mechanics/mechanic_serviceshistory';
import MobchangeForm from '.././module_mechanics/mechanics_mobchange';
import MobchangeList from '.././module_mechanics/mechanics_mobchangelist';
import AddProduct from '.././module_mechanics/mechanics_Products';
import ProductsList from '.././module_mechanics/mechanics_ProductsList';
import AddMecSales from '.././module_mechanics/mechanics_Sell';
import MecSalesList from '.././module_mechanics/mechanics_SellList';
import AddPurchase from '.././module_mechanics/mechanics_Purchases';
import PurchasesList from '.././module_mechanics/mechanics_PurchaseList';
import AddMecReturn from '.././module_mechanics/mechanics_Return';
import MecReturnsList from '.././module_mechanics/mechanics_ReturnList';
import MechanicsBarcode from '.././module_mechanics/mechanics_BarcodeGenerator';
import RootUsers from '.././module_roots/RootUsers';
import MessageSystem from '.././module_roots/MessageSystem';

export const autosConfig = {
  moduleId: 'autos',
  moduleName: 'Autos',
  icon: faCar,
  description: 'Autos & Vehicles Management System',
  
  dashboardComponent: DashboardHome,
  
  roles: {
    'admin_autosth': { level: 1, label: 'Admin (Thermal)', color: '#ef4444' },
    'manager_autosth': { level: 2, label: 'Manager (Thermal)', color: '#f59e0b' },
    'user_autosth': { level: 3, label: 'User (Thermal)', color: '#10b981' },
    'viewer_autosth': { level: 4, label: 'Viewer (Thermal)', color: '#6366f1' },
    'admin_autosap': { level: 1, label: 'Admin (Large)', color: '#dc2626' },
    'manager_autosap': { level: 2, label: 'Manager (Large)', color: '#d97706' },
    'user_autosap': { level: 3, label: 'User (Large)', color: '#059669' },
    'viewer_autosap': { level: 4, label: 'Viewer (Large)', color: '#4f46e5' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'vehicles', name: 'Vehicles', icon: faCar, order: 2 },
    { id: 'inventory', name: 'Inventory & Stock', icon: faBoxes, order: 3 },
    { id: 'services', name: 'Services', icon: faWrench, order: 4 },
    { id: 'sales', name: 'Sales & Transactions', icon: faMoneyBillWave, order: 5 },
    { id: 'system', name: 'System Settings', icon: faCog, order: 6 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUsers,
      roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: AddCustomer,
          icon: faUserPlus,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: CustomerList,
          icon: faUsersLine,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faBuilding,
      roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap'],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: AddSupplier,
          icon: faUserTie,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: SupplierList,
          icon: faBuildingUser,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        }
      ]
    },
    {
      id: 'cars',
      label: 'Cars',
      icon: faCar,
      roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap'],
      groupId: 'vehicles',
      position: 3,
      submenus: [
        {
          id: 'carsaddition',
          label: 'Cars List',
          component: CarList,
          icon: faCarOn,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        },
        {
          id: 'serviceslist',
          label: 'Service Names',
          component: ServiceNameList,
          icon: faWrench,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        }
      ]
    },
    {
      id: 'stock',
      label: 'Stock',
      icon: faCubes,
      roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap'],
      groupId: 'inventory',
      position: 4,
      submenus: [
        {
          id: 'addproduct',
          label: 'Add Product',
          component: AddProduct,
          icon: faCube,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        },
        {
          id: 'stocklist',
          label: 'Stock List',
          component: ProductsList,
          icon: faListAlt,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        }
      ]
    },
    {
      id: 'sales',
      label: 'Sales',
      icon: faCartShopping,
      roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap'],
      groupId: 'sales',
      position: 5,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: AddMecSales,
          icon: faCartPlus,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: MecSalesList,
          icon: faClipboardList,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        }
      ]
    },
    {
      id: 'purchases',
      label: 'Purchase',
      icon: faTruckFast,
      roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap'],
      groupId: 'inventory',
      position: 6,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: AddPurchase,
          icon: faCartPlus,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: PurchasesList,
          icon: faFileInvoice,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        }
      ]
    },
    {
      id: 'services',
      label: 'Car Services',
      icon: faWrench,
      roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap'],
      groupId: 'services',
      position: 7,
      submenus: [
        {
          id: 'newservice',
          label: 'New Service',
          component: ServiceForm,
          icon: faToolbox,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        },
        {
          id: 'serviceshistory',
          label: 'Services History',
          component: ServiceList,
          icon: faHistory,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        }
      ]
    },
    {
      id: 'oilchange',
      label: 'Oil Change',
      icon: faOilCan,
      roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap'],
      groupId: 'services',
      position: 8,
      submenus: [
        {
          id: 'addoilchange',
          label: 'Add Record',
          component: MobchangeForm,
          icon: faDroplet,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        },
        {
          id: 'oilchangelist',
          label: 'Oil Change History',
          component: MobchangeList,
          icon: faClock,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        }
      ]
    },
    {
      id: 'returns',
      label: 'Returns',
      icon: faArrowRotateLeft,
      roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap'],
      groupId: 'inventory',
      position: 9,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Return',
          component: AddMecReturn,
          icon: faRotateLeft,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        },
        {
          id: 'returnlist',
          label: 'Return List',
          component: MecReturnsList,
          icon: faListCheck,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserGroup,
      roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap'],
      groupId: 'management',
      position: 10,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: AddEmployee,
          icon: faUserPlus,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: MecEmployeeList,
          icon: faIdCard,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        }
      ]
    },
    {
      id: 'barcode',
      label: 'Barcodes',
      icon: faQrcode,
      roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap'],
      groupId: 'inventory',
      position: 11,
      submenus: [
        {
          id: 'barcodeprinting',
          label: 'Barcode Printing',
          component: MechanicsBarcode,
          icon: faPrint,
          roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap']
        }
      ]
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_autosth', 'admin_autosap'],
      groupId: 'system',
      position: 12,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_autosth', 'manager_autosth', 'user_autosth', 'admin_autosap', 'manager_autosap', 'user_autosap'],
      groupId: 'system',
      position: 13,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'todayTasks', label: "Today's Tasks", icon: 'faCheckCircle', value: 24 },
    { id: 'performance', label: 'Performance', icon: 'faChartLine', value: '85%' },
    { id: 'pendingActions', label: 'Pending Actions', icon: 'faClock', value: 12 },
    { id: 'activeUsers', label: 'Active Users', icon: 'faUsers', value: 38 }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard' },
    { key: 'Alt + C', description: 'Add Customer' },
    { key: 'Alt + L', description: 'Customer List' },
    { key: 'Alt + P', description: 'Stock List' },
    { key: 'Alt + S', description: 'New Sale' },
    { key: 'Alt + U', description: 'New Purchase' },
    { key: 'Alt + R', description: 'New Return' },
    { key: 'Alt + E', description: 'Add Employee' },
    { key: 'Alt + G', description: 'Employees List' },
    { key: 'Alt + V', description: 'Suppliers List' },
    { key: 'Alt + B', description: 'Barcode Printing' },
    { key: 'Alt + W', description: 'New Service' },
    { key: 'Alt + H', description: 'Services History' },
    { key: 'Alt + O', description: 'Add Oil Change Record' },
    { key: 'Ctrl + R / Cmd + R', description: 'Refresh Dashboard Data' },
    { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
  ]
};